<div
	[class]="
		cn(
			'flex flex-wrap gap-x-3',
			isHorizontal() ? 'flex-row gap-y-0' : 'flex-col gap-y-2 pt-5'
		)
	"
>
	@for (item of items(); track $index) {
		<div class="flex items-center gap-2">
			<svg-icon
				[attr.data-test-icon-name]="item.iconName"
				[class]="cn(iconColor(), 'size-4')"
				[src]="'assets/icons/' + item.iconName + '.svg'"
				[svgAriaLabel]="item.title"
			/>
			{{ item.title | translate }}
		</div>
	}
</div>
